<template>
  <div class="goods_info">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="goods_info_top_mbx width_center_1200">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.all_goods }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ goods_info.type }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ lang.goods_detail }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="goods_content width_center_1200">
      <div class="cont">
        <template>
          <div v-loading="loading" class="goods_info_top">
            <div class="goods_info_top_left">
              <div class="goods_image_item">
                <pic-zoom
                  :url="goods_images_thumb[chose_img_pos]"
                  :highUrl="goods_images[chose_img_pos]"
                />
              </div>
              <div class="swiper_pic">
                <div class="pic_zoom_list_left" @click="pre_img()">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="pic_zoom_list">
                  <ul :style="{'left':calleft + 'px'}">
                    <li
                      v-for="(v,k) in goods_images_thumb"
                      :key="k"
                      @click="click_silde_img(k)"
                      :class="chose_img_pos==k?'border_color':''"
                    >
                      <img :src="v" />
                    </li>
                  </ul>
                </div>
                <div class="pic_zoom_list_right" @click="next_img()">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="goods_info_top_right">
              <div class="goods_info_title">
                {{ goods_info.mercName }}
                <p>{{ goods_info.briefName }}</p>
              </div>
              <!-- 限时购 -->
              <div
                v-if="goods_info.isgift === 2 && goods_info.limitedstates !== 3"
                class="limited-time-purchase"
              >
                <div class="left">
                  <svg-icon iconClass="time_limit" />
                  <div class="title">{{ lang.time_limit_title }}</div>
                  <div class="desc">{{ lang.time_limit_desc }}…</div>
                </div>
                <div class="countdown-box">
                  <div class="tips">
                    <template v-if="goods_info.limitedstates === 1">{{ lang.time_limit_tips_start }}</template>
                    <template
                      v-if="goods_info.limitedstates === 2"
                    >{{ lang.time_limit_tips_conduct }}</template>
                    <template v-if="goods_info.limitedstates === 3">{{ lang.time_limit_tips_end }}</template>
                  </div>
                  <Countdown
                    :second="goods_info.second / 1000"
                    @timeup="getGoodsInfo(goods_info.productno)"
                  ></Countdown>
                </div>
              </div>
              <div
                v-if="goods_info.maxlable && goods_info.isgift !== 2"
                class="goods_info_label"
                :style="{ background: goods_info.maxlablebgcolor }"
              >
                <span>{{ goods_info.maxlable }}</span>
              </div>
              <div class="goods_info_price">
                <div class="cont">
                  <!-- 商品价格 -->
                  <template v-if="goods_info.isgift === 4">
                    <div class="d-price">
                      <span>{{ unit }}</span>
                      &nbsp;{{ goods_info.integralprice }} + {{ goods_info.integral }}{{ lang.integral }}
                    </div>
                  </template>
                  <template v-else-if="goods_info.isgift === 2 && goods_info.limitedstates === 2">
                    <div class="o-price">{{ unit }}&nbsp;{{ goods_info.price }}</div>
                    <div class="d-price">
                      <span>{{ unit }}</span>
                      &nbsp;{{ goods_info.limitedtimeprice }}
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="goods_info.pricediscount">
                      <div class="o-price">{{ unit }}&nbsp;{{ goods_info.price }}</div>
                      <div class="d-price">
                        <span>{{ unit }}</span>
                        &nbsp;{{ goods_info.pricediscount }}
                      </div>
                    </template>
                    <template v-else>
                      <div class="d-price">
                        <span>{{ unit }}</span>
                        &nbsp;{{ goods_info.price }}
                      </div>
                    </template>
                  </template>
                  <!-- 優惠標籤 -->
                  <div
                    v-if="goods_info.preferentiallabel"
                    class="item-tag"
                  >{{ goods_info.preferentiallabel }}</div>
                  <!-- 大標籤 -->
                  <div
                    v-if="goods_info.maxlable"
                    class="item-tag"
                    :style="{ background: goods_info.maxlablebgcolor }"
                  >{{ goods_info.maxlable }}</div>
                </div>
                <div v-if="goods_info.ptype === 0" class="stock">{{ lang.stock }}：{{ goods_info.canSaleCount }} {{ lang.unit }}</div>
              </div>
              <div class="goods_info_num">
                <div class="goods_info_num_title">{{ lang.num }}：</div>
                <el-input-number v-model="buyNum" :min="1" :max="goods_info.canSaleCount"></el-input-number>
                <div class="clear"></div>
              </div>
              <div class="goods_info_bottom">
                <div class="goods_info_btn">
                  <div
                    v-if="goods_info.isgift === 0"
                    class="goods_info_add_cart"
                    @click="addCart()"
                  >
                    <svg-icon iconClass="shop_cart" />
                    {{ lang.add_cart }}
                  </div>
                  <div
                    v-if="goods_info.canSaleCount === 0"
                    class="goods_info_buy end"
                  >{{ lang.sale_out }}</div>
                  <template v-else>
                    <div v-if="goods_info.isgift === 2" class="goods_info_buy" @click="buy()">
                      <span v-if="goods_info.limitedstates === 1">{{ lang.buy }}</span>
                      <span v-if="goods_info.limitedstates === 2">{{ lang.limit_buy }}</span>
                      <span v-if="goods_info.limitedstates === 3">{{ lang.buy }}</span>
                    </div>
                    <div v-else class="goods_info_buy" @click="buy()">
                      <span>{{ goods_info.canSaleCount === 0 ? lang.sale_out : lang.buy }}</span>
                    </div>
                  </template>
                </div>
                <div class="goods_info_action">
                  <div class="action">
                    <svg-icon iconClass="share" />
                    <div class="share-box">
                      <el-image :src="goods_info.sharewximg"></el-image>
                      <span>{{ lang.wechat_scan }}</span>
                    </div>
                  </div>
                  <div class="action" @click="handleCollect">
                    <svg-icon
                      :iconClass="goods_info.isproductCollection === 1 ? 'collect_cur' : 'collect'"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <!-- 优惠券 -->
          <coupon :list="couponList"></coupon>
          <div
            v-loading="loading"
            v-if="goods_info.vendlist && goods_info.vendlist.length"
            class="machine_list"
          >
            <div class="title">{{ lang.vend_title }}</div>
            <ul class="machine_ul" :class="{'show': showMachine }">
              <li
                v-for="(item, index) in goods_info.vendlist"
                :key="index"
                @click="updateInfo(item, index)"
              >
                <div class="cont">
                  <div
                    class="check-box"
                    :class="{ 'cur' : item.productno === goods_info.productno }"
                  ></div>
                  <div class="info">
                    <div class="name">
                      <el-image :src="item.vemimg" fit="cover" />
                      {{ item.vemName }}
                    </div>
                    <div class="address">{{ item.vemaddress }}</div>
                  </div>
                </div>
                <div class="right">
                  <div class="right-content">
                    <div class="location">
                      <svg-icon iconClass="location" />
                      {{ item.distance }}{{ item.distanceunit }}
                    </div>
                    <!-- <div class="btn">{{ lang.location }}</div> -->
                  </div>
                  <i class="el-icon-arrow-right" />
                </div>
              </li>
            </ul>
            <div
              v-if="goods_info.vendlist.length > 3"
              class="toggle-box"
              @click="showMachine =! showMachine"
            >
              {{ showMachine ? this.lang.pickup : this.lang.unfold }}
              <i
                :class="showMachine ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              />
            </div>
          </div>
          <div v-loading="loading" class="goods_detail">
            <div class="title">{{ lang.goods_detail }}</div>
            <div class="content" v-html="goods_info.details"></div>
          </div>
          <div class="goods_notes">
            <div class="title">{{ lang.notice }}</div>
            <div class="text">{{ lang.notice_content }}</div>
          </div>
        </template>
        <div v-if="goods_info.id === 0" class="empty_order" style="padding-top: 100px">
          <dl>
            <dt>
              <img src="/images/not-common-icon.png" alt />
            </dt>
            <dd>{{ lang.does_not_exist }}</dd>
            <dd class="btn">
              <router-link to="/">{{ lang.go_to_mall }}</router-link>
            </dd>
          </dl>
        </div>
      </div>
      <div class="recommend-goods">
        <div class="head">{{ lang.hot_sale }}</div>
        <div class="list">
          <goods-item v-for="item in goodsList" :key="item.id" :item="item" />
        </div>
      </div>
    </div>

    <div class="width_center_1200">
      <merchant-promise></merchant-promise>
    </div>

    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoodsItem from './components/goods.vue'
import PicZoom from '@/components/PicZoom/index' // 放大镜组件
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import MerchantPromise from '@/components/MerchantPromise/index'
import Coupon from '@/components/Coupon/index'
import { getproductdetail, getproductlist, addproductColl } from '@/api/product'
import { getbuydetail } from '@/api/order'
import { getcouponlist } from '@/api/coupon'
import Countdown from '@/components/Countdown'
import { addcartbyproduct } from '@/api/cart'
export default {
  components: {
    GoodsItem,
    PicZoom, // 放大镜
    ShopTop,
    ShopFoot,
    MerchantPromise,
    Coupon,
    Countdown
  },
  data() {
    return {
      goodsList: [],
      goods_info: {
        comment_num: 0,
        goods_images_thumb_200: ['/images/loading_pic_200.png']
      },
      buyNum: 1, // 购买数量
      chose_img_pos: 0,
      goods_images_thumb: ['/images/loading_pic_400.png'],
      goods_images: [],
      calleft: 0,
      machineData: {
        index: 0
      },
      showMachine: false,
      loading: false,
      couponList: []
    }
  },
  computed: {
    lang() {
      return this.$t('goods_info')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  watch: {
    location: {
      handler(val) {
        if (val) {
          this.getGoodsInfo(this.$route.params.goods_id)
          this.getCouponList()
          this.getGoodsList()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取优惠券
    getCouponList() {
      getcouponlist().then(({ data }) => {
        this.couponList = data
      })
    },
    // 更新商品信息
    updateInfo(item, index) {
      this.machineData.index = index
      this.getGoodsInfo(item.productno)
    },
    // 获取商品信息
    getGoodsInfo(productno) {
      this.loading = true
      getproductdetail({
        productno,
        ...this.location
      }).then((res) => {
        this.loading = false
        if (res.data.isgift === 2) {
          const limitedtimestart =
            Number(res.data.limitedtimestart) - new Date().getTime()
          const limitedtimeend =
            Number(res.data.limitedtimeend) - new Date().getTime()
          res.data.second =
            res.data.limitedstates === 1 ? limitedtimestart : limitedtimeend
        }
        this.goods_info = res.data
        this.goods_images_thumb = res.data.thumbnailsImage.split(',') || []
      })
    },
    // 获取热卖商品
    getGoodsList() {
      getproductlist({
        ptype: 0,
        pageNum: 1,
        pageSize: 5,
        ishot: 1
      }).then(({ data }) => {
        this.goodsList = data.data
      })
    },
    // 点击缩略图幻灯片图片
    click_silde_img(e) {
      this.chose_img_pos = e
    },
    pre_img() {
      this.calleft -= 228
      if (this.calleft < -228) {
        this.calleft = 0
      }
    },
    next_img() {
      this.calleft += 228
      if (this.calleft > 0) {
        this.calleft = -228
      }
    },
    // 收藏
    async handleCollect() {
      await this.$checkLogin()
      addproductColl({
        productno: this.goods_info.productno
      }).then((res) => {
        if (res.code === 1) {
          this.goods_info.isproductCollection =
            this.goods_info.isproductCollection === 1 ? 0 : 1
        }
      })
    },
    // 立即购买
    async buy() {
      await this.$checkLogin()
      const params = {
        productno: this.goods_info.productno,
        buynum: this.buyNum,
        isgift: this.goods_info.isgift
      }
      getbuydetail(params).then(() => {
        this.$router.push({
          path: '/order/confirm',
          query: params
        })
      })
    },
    // 加入购物车
    async addCart() {
      await this.$checkLogin()
      addcartbyproduct({
        productno: this.goods_info.productno,
        productnum: this.buyNum,
        vemId: this.goods_info.vemId
      }).then((res) => {
        if (res.code === 1) {
          this.$store.dispatch('updateCart')
          this.$message({
            type: 'success',
            message: res.msg
          })
        }
      })
    },
    // 切换图片
    push_comment_images(e) {
      this.comment_image = []
      e.forEach((res) => {
        this.comment_image.push(res)
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path != from.path && this.location) {
      this.getGoodsInfo(to.params.goods_id)
      this.getGoodsList()
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
.goods_info_top_mbx {
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
}
.goods_content {
  padding-bottom: 50px;
  .cont {
    float: left;
    width: 908px;
  }
  .recommend-goods {
    float: right;
    width: 272px;
    margin-left: 20px;
    background: #fff;
    border-radius: 12px;
    .head {
      padding: 20px;
      font-size: 18px;
      color: #4f4f4f;
      font-weight: 700;
    }
    .product {
      margin: 0 18px 20px;
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 12px;
      box-shadow: 7px 7px 9px 0px #f1f4f9;
      padding: 10px 15px 10px;
      /deep/ img {
        width: 216px;
        height: 216px;
      }
      .title {
        color: #4f4f4f;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .stock {
        padding: 4px 0 0;
        color: #aaaaaa;
        font-size: 12px;
      }
      .price {
        display: flex;
        align-items: flex-end;
        padding-bottom: 6px;
        .item-price {
          &:first-child {
            font-size: 10px;
            color: #000;
            margin-right: 10px;
            text-decoration: line-through;
          }
          font-size: 16px;
          color: #ff0000;
          span {
            font-size: 12px;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .add {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ec9221;
          min-width: 80px;
          padding: 0 10px;
          box-sizing: border-box;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          color: #ffffff;
          font-size: 12px;
        }
      }
    }
    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      top: 0;
      background: #aaa;
      border: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
    }
    /deep/ .el-input-number--small {
      width: 74px;
      line-height: 24px;
    }
    /deep/ .el-input-number {
      .el-input {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-input__inner {
        padding: 0;
        width: 28px;
        height: 20px;
        line-height: 20px;
        border: 1px solid #aaa;
        color: #000;
        font-size: 12px;
      }
    }
  }
}
.goods_info_top {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 32px;
  min-height: 400px;
}
.goods_info_top_left {
  width: 260px;
  margin-right: 30px;
  float: left;
  box-sizing: border-box;
  .goods_image_item {
    width: 260px;
    height: 260px;
    display: block;
    border-bottom: 1px solid #efefef;
  }
  .swiper_pic {
    position: relative;
    overflow: hidden;
    width: 260px;
    height: 86px;
    margin: 0 auto;
    .pic_zoom_list_left {
      position: absolute;
      top: 0;
      left: 0;
      width: 22px;
      font-weight: bold;
      font-size: 20px;
      line-height: 86px;
      color: #666;
      cursor: pointer;
      i {
        margin-left: -2px;
      }
    }
    .pic_zoom_list_right {
      position: absolute;
      top: 0;
      right: 0;
      width: 22px;
      font-weight: bold;
      font-size: 20px;
      line-height: 86px;
      color: #666;
      cursor: pointer;
      i {
        padding-left: 4px;
      }
    }
    .pic_zoom_list {
      position: relative;
      overflow: hidden;
      width: 218px;
      height: 86px;
      margin: 0 auto;
      ul {
        position: absolute;
        left: 0;
        width: 2400px;
        margin: 0 auto;
        transition: all 0.5s;
      }
      ul li {
        float: left;
        margin: 10px 10px 10px 0;
        border: 1px solid #efefef;
        img {
          display: flex;
          width: 64px;
          height: 64px;
        }
      }
      ul li:hover {
        border-color: #ef8500;
      }
      ul li:last-child {
        margin-right: 0;
      }
      ul li.border_color {
        border-color: #ef8500;
      }
    }
  }
}
.goods_info_top_right {
  float: left;
  width: 554px;
  font-size: 14px;
  background: #fff;
  .goods_info_title {
    position: relative;
    font-size: 18px;
    color: #4f4f4f;
    p {
      color: #4f4f4f;
      font-size: 12px;
      padding: 8px 0 15px;
    }
  }

  .goods_info_label {
    display: inline-block;
    width: 478px;
    height: 50px;
    line-height: 50px;
    margin-bottom: 24px;
    background-image: linear-gradient(112deg, #e17d00, #d18320);
    span {
      padding-left: 50px;
      font-size: 16px;
      color: #fff;
    }
  }
  .goods_info_price {
    display: flex;
    justify-content: space-between;
    .cont {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .o-price {
      color: #4f4f4f;
      font-size: 14px;
      text-decoration: line-through;
      padding-right: 20px;
    }
    .d-price {
      color: #ff0000;
      font-weight: 700;
      font-size: 20px;
      span {
        font-weight: 400;
        font-size: 14px;
      }
    }
    .item-tag {
      text-align: center;
      padding: 0 8px;
      height: 18px;
      line-height: 18px;
      background: #ff0000;
      border-radius: 4px;
      font-size: 12px;
      color: #ffffff;
      margin-left: 10px;
      margin-bottom: 4px;
    }
    .stock {
      color: #4f4f4f;
      font-size: 12px;
    }
  }
  .goods_info_num {
    padding: 20px 0;
    display: flex;
    align-items: center;
    .goods_info_num_title {
      color: #000;
      font-size: 14px;
      margin-right: 10px;
    }
    .goods_info_num_jian,
    .goods_info_num_jia {
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #666;
      border: 1px solid #ec9221;
      border-radius: 6px;
      i {
        font-size: 12px;
        color: #ec9221;
      }
    }
    .goods_info_num_input input {
      text-align: center;
      height: 24px;
      outline: none;
      width: 50px;
      box-sizing: border-box;
      padding: 0 8px;
      font-size: 14px;
      color: #000;
      border: 0;
    }
  }
  .goods_info_btn {
    display: flex;
  }
  .goods_info_bottom {
    display: flex;
    justify-content: space-between;
  }
  .goods_info_add_cart,
  .goods_info_buy {
    text-align: center;
    width: 136px;
    line-height: 40px;
    margin-right: 15px;
    background: #ffd39b;
    border-radius: 6px;
    font-size: 16px;
    color: #ef8500;
    cursor: pointer;
    &.end {
      background: #aaa;
      color: #fff;
    }
  }
  .goods_info_add_cart {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 185px;
    background: #ef8500;
    color: #fff;
    font-size: 16px;
    .svg-icon {
      margin-right: 10px;
    }
  }
  .goods_info_action {
    display: flex;
    align-items: center;
    .action {
      position: relative;
      margin-left: 20px;
      &:first-child {
        &:hover .share-box {
          display: block;
        }
      }
      .share-box {
        display: none;
        position: absolute;
        left: -100%;
        border: 1px solid #efeff1;
        border-radius: 4px;
        text-align: center;
        .el-image {
          display: flex;
          width: 85px;
          height: 85px;
        }
        span {
          display: block;
          margin-top: -2px;
          padding-bottom: 4px;
          font-size: 12px;
          color: #4f4f4f;
        }
      }
      .svg-icon {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
}
.goods_detail {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  .title {
    height: 40px;
    line-height: 40px;
    background: #ec9221;
    padding: 0 15px;
    font-size: 16px;
    color: #fff;
    margin-bottom: 15px;
  }
  /deep/ .content {
    img {
      display: flex;
      width: 100%;
      margin: 0 auto;
    }
  }
}
.goods_notes {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 160px;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #4f4f4f;
    text-align: center;
    padding-bottom: 10px;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #4f4f4f;
    padding-bottom: 16px;
  }
}
.goods_info_num {
  /deep/ .el-input-number__increase,
  /deep/ .el-input-number__decrease {
    top: 0;
    background: #fff;
    border: 0;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    font-size: 14px;
    border: 1px solid #ec9221;
    color: #ffffff;
    i {
      color: #ec9221;
    }
  }
  /deep/ .el-input-number--small {
    width: 116px;
    line-height: 24px;
  }
  /deep/ .el-input-number {
    .el-input {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-input__inner {
      padding: 0;
      width: 50px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #fff;
      color: #000;
      font-size: 14px;
    }
  }
}
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  margin-right: 5px;
  &.cur {
    background: #ec9221;
  }
}
.machine_list {
  padding: 15px;
  background: #ffffff;
  margin-bottom: 15px;
  border-radius: 12px;
  .title {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
  }
  
  .machine_ul {
    max-height: 206px;
    overflow: hidden;
    &.show {
      overflow: inherit;
      height: auto;
      max-height: 2000px!important;
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eee;
      padding: 14px 0;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      .cont {
        display: flex;
        align-items: center;
      }
      .info {
        margin-left: 15px;
      }
      .name {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #000;
        margin-bottom: 4px;
        .el-image {
          width: 27px;
          height: 16px;
          margin-right: 8px;
        }
      }
      .address {
        font-size: 12px;
        color: #4f4f4f;
      }
      .right {
        display: flex;
        align-items: center;
      }
      .right-content {
        margin-right: 15px;
      }
      .location {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #aaaaaa;
        margin-bottom: 4px;
      }
      .btn {
        text-align: right;
        font-size: 12px;
        color: #0061b5;
      }
    }
  }
  .toggle-box {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    font-size: 14px;
    color: #4f4f4f;
    cursor: pointer;
    i {
      margin-left: 4px;
      font-size: 18px;
    }
  }
}
.coupon-list {
  margin-top: -20px;
  padding: 20px 0;
}

/* 限时购 */
.limited-time-purchase {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url(../../assets/images/limited_time_bg.png) no-repeat;
  background-size: 100% 100%;
  height: 50px;
  margin-bottom: 20px;
  padding: 0 10px 0 16px;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    .title {
      padding: 0 15px 0 4px;
      color: #fff;
      font-size: 16px;
    }
    .desc {
      color: #fff;
      font-size: 12px;
    }
  }
  .countdown-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .tips {
      margin-bottom: 5px;
      color: #fff;
      font-size: 12px;
    }
    /deep/ .uni-countdown {
      color: #fff;
      .uni-countdown__number:first-child {
        width: auto !important;
      }
      .uni-countdown__number:nth-of-type(n + 2) {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 19px;
        height: 19px;
        line-height: 19px;
        background: #5b5b5b;
        border-radius: 0 !important;
      }
      span {
        color: #fff;
        font-size: 10px;
      }
      .uni-countdown__splitor {
        color: #fff !important;
      }
    }
  }
}
</style>